
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[collection]/[category]/[article]",
      function () {
        return require("private-next-pages/help/[collection]/[category]/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[collection]/[category]/[article]"])
      });
    }
  